export default __webpack_public_path__ + "static/media/audio-challenge.5df1275c.png";